'use strict';

export default class AddController {

  /*@ngInject*/
  constructor($http, $state, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.toaster = toaster;

    this.newCarouse = {};
  }

  $onInit() {
  }

  save() {
    if (!this.checkData()) {
      return;
    }
    this.$http.post(`/api/carousels`, this.newCarouse).then(res => {
      this.$state.go('carousel.show', {id: res.data._id});
    });
  }

  checkStr(str) {
    if (str && typeof str == 'string') {
      str = str.trim();
    }
    return str;
  }

  checkArr(arr) {
    let res = false;
    arr.forEach(item => {
      if (item.trim().length > 0) {
        res = true;
      }
    });
    return res;
  }

  checkData() {
    console.log(this.newCarouse);
    if (this.checkStr(this.newCarouse.model) && this.newCarouse.deviceWidth && this.newCarouse.deviceHeight && this.checkArr(this.newCarouse.devices)) {
      return true;
    }

    this.toaster.pop({
      type: 'error',
      title: '请填写必填项',
      timeout: 3 * 1000
    });
    return false;
  }

}



// WEBPACK FOOTER //
// ./client/app/carousel/add/add.controller.js